var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLiked = function SvgLiked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5.668h4.288a1.667 1.667 0 0 1 1.566 2.236l-2.121 5.834a1.67 1.67 0 0 1-1.567 1.097H7.334l-2.5-1.25V14c0 .46-.373.834-.834.834H1.5A.833.833 0 0 1 .667 14V5.668c0-.46.373-.833.833-.833H4c.46 0 .834.373.834.833H6.5l2.65-4.637a1.457 1.457 0 0 1 2.567.071l.178.356a2.65 2.65 0 0 1 .2 1.828z"
  })));
};
export default SvgLiked;